module.exports = __webpack_public_path__ + "img/2-detail.f4325eab.webp";